// Years-coaching counts that keep themselves current.
//
// Templates write the count for the year they were last edited, so the
// page reads correctly with JS off and to crawlers that don't run it:
//
//   <span data-years-since="2000" data-years-format="words">twenty-six</span>
//
// This swaps in the count for the current year. Formats: "number"
// (default) → 27, "words" → twenty-seven, "Words" → Twenty-seven.

const ONES = ["", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine",
    "ten", "eleven", "twelve", "thirteen", "fourteen", "fifteen", "sixteen",
    "seventeen", "eighteen", "nineteen"];
const TENS = ["", "", "twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety"];

function toWords(n) {
    if (n < 20) return ONES[n];
    const ones = n % 10;
    return TENS[Math.floor(n / 10)] + (ones ? "-" + ONES[ones] : "");
}

export default function years() {
    const now = new Date().getFullYear();

    document.querySelectorAll("[data-years-since]").forEach((el) => {
        const n = now - parseInt(el.dataset.yearsSince, 10);
        if (!(n > 0 && n < 100)) return;

        const format = el.dataset.yearsFormat || "number";
        if (format === "number") {
            el.textContent = String(n);
        } else {
            const words = toWords(n);
            el.textContent = format === "Words" ? words[0].toUpperCase() + words.slice(1) : words;
        }
    });
}
